import React, {  useState, useContext } from "react";
import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBNavbarToggler,
  MDBCollapse,
  MDBFormInline,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBIcon,
  MDBBtn,
} from "mdbreact";
import { useHistory, withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import "./navbar.css";
import { MovieDataContext } from "../../context/discover_data";

const NavbarPage = (props) => {
  let history = useHistory();

  
  const [isOpen, setIsOpen] = useState(false);
  const [searchItem, setSearchItem] = useState("");
  const handleSearch = (e) => {
    setSearchItem(e.target.value);
  };
  const onSubmit =  (e) => {
    e.preventDefault();
    history.push(`/search/${searchItem}`);
  };
  const toggleCollapse = () => {
    if (isOpen == true) {
      setIsOpen(false);
    } else if (isOpen == false) {
      setIsOpen(true);
    }
  };

  return (
    <MDBNavbar className="myNav" dark expand="md">
      <MDBNavbarToggler onClick={toggleCollapse} />
      <MDBCollapse id="navbarCollapse3" isOpen={isOpen} navbar>
        <MDBNavbarNav left>
       
          <MDBNavItem>
            <h5>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2"> Discover</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i>   <Link to={`/discover/toprated`}>Top Rated</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i>  <Link to={`/discover/popular`}>Popular</Link>
                  </MDBDropdownItem>
                 
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i>   <Link to={`/discover/upcoming`}>Upcoming</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i>   <Link to={`/discover/nowplaying`}>Now Playing</Link>
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </h5>
          </MDBNavItem>
          <MDBNavItem>
            <h5>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2">Genres</span>
                </MDBDropdownToggle>
                <h4>
                <MDBDropdownMenu>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i> <Link to={`/sort/Action`}>Action</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i> <Link to={`/sort/Horror`}>Horror</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i> <Link to={`/sort/Animation`}>Animation</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i>  <Link to={`/sort/Comedy`}>Comedy</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i>  <Link to={`/sort/Crime`}>Crime</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i>   <Link to={`/sort/Fantasy`}>Fantasy</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i> <Link to={`/sort/Mystery`}>Mystery</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i> <Link to={`/sort/Romance`}>Romance</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i> <Link to={`/sort/Thriller`}>Thriller</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i>    <Link to={`/sort/History`}>History</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                  <i class="far fa-dot-circle"></i>  <Link to={`/sort/War`}>War</Link>
                  </MDBDropdownItem>
                  
                </MDBDropdownMenu>
                </h4>
              </MDBDropdown>
            </h5>
          </MDBNavItem>
        </MDBNavbarNav>

        <MDBNavbarNav right>
          <MDBNavItem>
            <MDBDropdown>
              <MDBNavbarNav right>
             
                <MDBFormInline
               
                  onSubmit={onSubmit}
                >
                  <input
                    className="form-control "
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                 
                    onChange={handleSearch}
                  />
                  
                </MDBFormInline>
              </MDBNavbarNav>
            </MDBDropdown>
          </MDBNavItem>
        </MDBNavbarNav>
      </MDBCollapse>
    </MDBNavbar>
  );
};

export default NavbarPage;
